module.exports = __webpack_public_path__ + "static/media/21-6.7cd95b25.mp3";